"use client";

import { useEffect, useState } from "react";
import { Product } from "../../types/types";
import { useVariant } from "../../hooks/useVariant/useVariant";

export const FooterEvents = ({ product }: { product: Product }) => {
  const [rviLoaded, setRviLoaded] = useState<boolean>(false);
  const selectedVariant = useVariant(product);

  const productId = product.aliases.pimProductId;
  const skuId = selectedVariant.variant.aliases.skuId;

  useEffect(() => {
    const updateRviLoadedState = () => {
      setRviLoaded(true);
    };
    document.body.addEventListener(
      "jl-events.browser.rviLoaded",
      updateRviLoadedState,
    );

    return () => {
      document.body.removeEventListener(
        "jl-events.browser.rviLoaded",
        updateRviLoadedState,
      );
    };
  }, []);

  useEffect(() => {
    if (rviLoaded) {
      document.body.dispatchEvent(
        new CustomEvent("jl-events.browser.displayedProduct", {
          detail: { productId, skuId },
        }),
      );
    }
  }, [rviLoaded, skuId, productId]);

  return null;
};
